<template>

    <div :class="{ 'isDevOrStageEnv': isDevOrStageEnv }" v-if="!isLoading">

        <!-- progress bar -->
        <nprogress-container></nprogress-container>

        <!-- ENV Notice -->
        <env-notice v-if="!$route.meta.isPrintView && isDevOrStageEnv"></env-notice>

        <!-- DEPRECATED IE VERSION -->
        <template v-if="$store.getters.isOldIEVersion !== false">

            <transition name="fade" appear>
                <old-browser></old-browser>
            </transition>

        </template>

        <template v-else>

            <!-- USER IS LOGGED IN -->
            <template v-if="isLoggedIn">

                <!-- DEFAULT VIEWS -->
                <template v-if="!$route.meta.isPrintView">


                    <div id="wrapper" :class="[isMenuOpen ? 'menuOpened' : 'menuClosed']" :mandate="mandateId">

                        <!-- Navigation Top -->
                        <navigation-top></navigation-top>

                        <!-- Navigation Main -->
                        <navigation-main></navigation-main>

                        <!-- Content -->
                        <div id="content-wrapper">
                            <transition :name="transitionName" @after-enter="afterEnter" appear>
                                <router-view :key="$route.fullPath"></router-view>
                            </transition>
                        </div>

                        <!-- language modal container -->
                        <modal-label v-if="$store.getters.isModalOpen"></modal-label>

                    </div> <!-- // #wrapper -->

                </template>


                <!-- PRINT VIEWS -->
                <template v-else-if="$route.meta.isPrintView == true">

                    <transition :name="transitionName" @after-enter="afterEnter" appear>
                        <router-view :key="$route.fullPath"></router-view>
                    </transition>

                </template>

            </template>


            <!-- ... otherwise show LOGIN SCREEN -->
            <template v-else>

                <transition :name="transitionName" appear>
                    <router-view :key="$route.fullPath"></router-view>
                </transition>

            </template>

        </template>

    </div>
</template>


<script>
import NavigationTop from './components/Navigation-top.vue';
import NavigationMain from './components/Navigation-main.vue';
import oldBrowser from './components/oldBrowser.vue';
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
import envNotice from './components/envNotice.vue';

export default {

    name: 'app',

    components: {
        NavigationTop,
        NavigationMain,
        NprogressContainer,
        oldBrowser,
        envNotice
    },

    data() {
        return {
            isLoading: true,
        }
    },

    computed: {

        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },

        transitionName() {
            return this.$route.meta && this.$route.meta.transition
                ? this.$route.meta.transition
                : "page-fade"; // "slide-left-";
        },

        isMenuOpen() {
            return this.$store.getters.getMenuStatus;
        },

        mandateId() {
            if (this.$store.getters.getUser && this.$store.getters.getUser.userRole && this.$store.getters.getUser.userRole.name == 'AdministratorOnline') {
                return 5;
            }
            return (this.$store.getters.getUser.mandate && this.$store.getters.getUser.mandate.id > 0) ? this.$store.getters.getUser.mandate.id : 0;

        },

        isDevOrStageEnv() {
            return this.$store.getters.getEnvType && (this.$store.getters.getEnvType == 'dev' || this.$store.getters.getEnvType == 'stage');
        }

    },

    async created() {
        this.isLoading = true;
        await this.$store.dispatch('getApiVersion');
        this.isLoading = false;
    },

    mounted() {

    },

    methods: {

        afterEnter() {
            this.$root.$emit("triggerScroll");
        },

    },

    watch: {

        'this.$route.fullPath'(val) {
            console.log("route: ", val);
        }

    }

}
</script>

<style lang="sass" src="bulma/sass/utilities/variables.sass"></style>

<style lang="scss">
$backgroundColor: #e9ecf1;

html,
body {
    background-color: #e8ecf0 !important
}

$tablet: 2000px !important;
$desktop: 2800px !important;
$widescreen: 2992px !important;

:not(.switchery).is-info {
    background-color: #45a7d6;
}

#wrapper[mandate="1"] #navigation-wrapper {
    background: #c199dd
}

/* test user */
#wrapper[mandate="5"] #navigation-wrapper {
    background: #8fa889
}

/* online-admin */
</style>


<style scoped>
.for-print {
    padding: 30px;
    margin: 10px;
    border: 1px solid red;
    border-radius: 4px;
}

#wrapper.hidden,
.for-print.hidden {
    display: none;
}


.slide-left--enter-active,
.slide-left--leave-active,
.slide-right--enter-active,
.slide-right--leave-active {
    transition: opacity 0.3s, transform 0.3s;
}

.slide-left--enter,
.slide-right--leave-to {
    opacity: 0;
    transform: translate3d(20vw, 0, 0);
}

.slide-right--enter,
.slide-left--leave-to {
    opacity: 0;
    transform: translate3d(-20vw, 0, 0);
}
</style>


<style lang="css" src="vue-blu/dist/css/vue-blu.min.css"></style>
<style lang="css" src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" src="./assets/css/base.css"></style>
<style lang="scss" src="./assets/css/base.scss"></style>
